import React, { useEffect, useRef } from 'react';

import { useGlobal } from '../contexts/global';
import '../assets/scss/components/Regulamento.scss';

const Regulamento = () => {
  const modal = useRef();
  const { setShowRegulamento } = useGlobal();

  const back = (e) => {
    e.stopPropagation();
    setShowRegulamento(false);
  };

  const handleModal = (e) => {
    if (modal.current !== null && modal.current !== undefined) {
      if (!modal.current.contains(e.target)) {
        back(e);
      }
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleModal);
    return () => {
      document.removeEventListener('mousedown', handleModal);
    };
  }, []);

  return (
    <div className="wrapper-regulamento">
      <div className="modal" ref={modal}>
        <div className="container">
          <h1 className="title">Regulamento</h1>
          <div className="content">
            <p>CAPÍTULO I – DO PRÊMIO</p>
            <br />
            <p>
              Art. 1º – O Prêmio SP8 PIZZA contribui para a valorização e o
              reconhecimento das pizzarias, de seus profissionais, de seus
              serviços e de seus produtos, que ajudam a construir a convivência
              e a gastronomia na cidade de São Paulo.
            </p>
            <br />
            <p>
              Art. 2º – Atuando diretamente na valorização das pizzarias, o SP8
              PIZZA também contribui para estimular a população a reconhecer e a
              valorizar as pizzarias de sua comunidade, de seu bairro e de sua
              cidade.
            </p>
            <br />
            <p>
              Art. 3º – O Prêmio SP8 PIZZA foi idealizado e é promovido pela
              M.Pad Produções, Marketing e Conteúdo (razão social: Miguel Angelo
              Padberg Icassatti).
            </p>
            <br />
            <p>CAPÍTULO II – DA PARTICIPAÇÃO</p>
            <br />
            <p>
              Art. 1º – A Fase 1 do SP8 PIZZA é aberta a votação do público
              consumidor, que pode indicar seus votos a quaisquer pizzarias
              estabelecidas dentro dos limites da cidade de São Paulo nas
              seguintes categorias: 1) Pizza de Calabresa 2) Pizza Marguerita 3)
              Pizza Portuguesa 4) Pizzaria 5) Delivery.
            </p>
            <br />
            <p>
              Art. 2º – Para efeito de participação no SP8 PIZZA serão
              considerados “Pizzarias” aqueles estabelecimentos historicamente
              reconhecidos como “Pizzarias”, além de “Pizza-bares” e
              restaurantes em que o cardápio de pizzas tenha no mínimo três
              sabores diferentes.
            </p>
            <br />
            <p>
              Art.3º – A Fase 2 do SP8 PIZZA é aberta às três pizzarias com
              maior número de votos, na soma de todas as categorias, de cada uma
              das cinco regiões da cidade de São Paulo, de acordo com as faixas
              de CEP: Zonas Norte, Sul, Leste, Oeste e Centro.
            </p>
            <br />
            <p>CAPÍTULO III – DAS POSSIBILIDADES DE PREMIAÇÃO</p>
            <br />
            <p>
              Art. 1° – Na Fase 1, uma pizzaria poderá ser premiada em apenas
              uma categoria e poderá sagrar-se vencedora em apenas uma
              categoria, ainda que receba o maior número de votos em duas ou
              mais categorias. Caso receba o maior número de votos em mais de
              uma categoria, ela será considerada, para fins de premiação, a
              vencedora apenas da categoria na qual a pizzaria tiver recebido o
              maior número de votos absolutos.
            </p>
            <br />
            <p>
              Art. 2º – Em caso de empate na Fase 1, será considerado como
              critério de desempate o número total de votos recebidos pela
              pizzaria em todas as categorias. Ao persistir o empate, o prêmio
              será dividido e entregue a ambas.
            </p>
            <br />
            <p>
              Art. 3º – Para a Fase 2 serão levadas 15 pizzarias com mais
              indicações na Fase 1, assim distribuídas e organizadas: as 3 com
              mais indicações localizadas na Zona Norte; as 3 com mais
              indicações localizadas na Zona Leste; as 3 com mais indicações
              localizadas na Zona Sul; as 3 com mais indicações localizadas na
              Zona Oeste; as 3 com mais indicações localizadas na região
              central.
            </p>
            <br />
            <p>CAPÍTULO IV – DA INDICAÇÃO E DA VOTAÇÃO</p>
            <br />
            <p>
              Art. 1º – A premiação se dará por indicação e voto realizados em
              duas fases, única e exclusivamente por meio da plataforma digital{' '}
              <a
                href="https://www.sp8pizza.com.br"
                target="_blank"
                rel="noreferrer"
                style={{ color: '#40b2f5', textDecoration: 'underline' }}
              >
                www.sp8pizza.com.br
              </a>
              .
            </p>
            <br />
            <p>
              Art. 2º – Na Fase 1, a seleção dos indicados em cada categoria se
              dará apenas pelo voto do público, que pode indicar apenas 1 (um)
              estabelecimento em cada uma das categorias.
            </p>
            <br />
            <p>
              Art. 3º – É permitido indicar a mesma Pizzaria em uma ou mais
              categorias assim como é permitido indicar uma pizzaria diferente
              para cada categoria.
            </p>
            <br />
            <p>Art 4º – É permitido voto em branco.</p>
            <br />
            <p>
              Art. 5º – Cada pessoa pode votar apenas uma vez em cada fase,
              mediante validação prévia de cadastro. Serão considerados válidos
              as indicações e os votos feitos no período de: 3 a 14 de junho de
              2026 (Fase 1); 19 a 28 de junho de 2026 (Fase 2).
            </p>
            <br />
            <p>
              Art. 6º – A Fase 1 começa às 10h do dia 3 de junho de 2026 e se
              encerra às 23h59 do dia 14 de junho de 2026. A Fase 2 começa às
              10h do dia 19 de junho e se encerra às 23h59 do dia 28 de junho de
              2026.
            </p>
            <br />
            <p>
              Art. 7º – Na Fase 2, haverá a participação do júri técnico,
              formado por profissionais de comunicação e de gastronomia
              convidados pela organização do SP8 PIZZA, cuja identidade será
              mantida em sigilo.
            </p>
            <br />
            <p>
              Art. 8º – Na Fase 2, a soma dos votos do júri técnico terá peso de
              50% na apuração do resultado.
            </p>
            <br />
            <p>
              Art. 9° – O SP8 PIZZA se compromete a manter a confidencialidade
              das indicações e votos de cada votante. As informações e os
              resultados a serem divulgados não estarão atrelados a nenhuma
              fonte específica e serão apresentados no conjunto da premiação.
            </p>
            <br />
            <p>
              Art. 10º – Na Fase 2, o SP8 PIZZA reserva-se o direito de
              desqualificar uma pizzaria finalista caso ela não instale ou não
              utilize o enxoval promocional do concurso em seu estabelecimento
              (banner, móbiles, display, caixas de pizza e/ou materiais
              similares).
            </p>
            <br />
            <p>
              Art. 11º – Serão consideradas pizzarias “Hors Concours” aquelas
              que foram campeãs de uma mesma categoria em três edições do SP8
              PIZZA. Os votos a elas conferidos serão desconsiderados na
              presente edição, para aquela respectiva categoria.
            </p>
            <br />
            <p>CAPÍTULO V – DOS RESULTADOS</p>
            <br />
            <p>
              Art. 1° – Serão concedidos prêmios (troféus e/ou diplomas) aos
              vencedores de cada categoria. Na Fase 1: 1) Pizza de calabresa; 2)
              Pizza marguerita; 3) Pizza Portuguesa, 4) Pizzaria, 5) Delivery.
              Na Fase 2: 6) Melhor Pizzaria da Zona Norte; 7) Melhor Pizzaria da
              Zona Leste; 8) Melhor Pizzaria da Zona Sul; 9) Melhor Pizzaria da
              Zona Oeste; 10) Melhor Pizzaria da Região Central.
            </p>
            <br />
            <p>
              Art. 2º – Serão concedidos diplomas de finalistas nas categorias
              da Fase 2: 1) Pizzaria da Zona Norte; 2) Pizzaria da Zona Leste;
              3) Pizzaria da Zona Sul; 4) Pizzaria da Zona Oeste; 5) Pizzaria da
              Região Central.
            </p>
            <br />
            <p>
              Art. 3º – Será enviado por e-mail certificado de participação
              digital a todas as pizzarias que receberam pelo menos uma
              indicação na Fase 1, desde que se consiga obter um e-mail para
              contato e envio do mesmo.
            </p>
            <br />
            <p>
              CAPÍTULO VI – DA DIVULGAÇÃO DO RESULTADO E ENTREGA DOS PRÊMIOS
            </p>
            <br />
            <p>
              Art. 1° – Os resultados serão divulgados no dia 4 de julho de 2026
              no evento “Festa da Pizza” e serão publicados na plataforma{' '}
              <a
                href="https://www.sp8pizza.com.br"
                target="_blank"
                rel="noreferrer"
                style={{ color: '#40b2f5', textDecoration: 'underline' }}
              >
                www.sp8pizza.com.br
              </a>{' '}
              e redes sociais do SP8 PIZZA.
            </p>
            <br />
            <p>
              Art. 2° – No dia 4 de julho de 2026 acontecerá o evento de
              premiação, com entrega dos troféus e certificados aos finalistas e
              vencedores de cada categoria.
            </p>
            <br />
            <p>CAPÍTULO VII – DAS CONSIDERAÇÕES FINAIS</p>
            <br />
            <p>
              Art. 1° – Ao participarem do evento de premiação, os presentes
              autorizam automaticamente o SP8 PIZZA a utilizar, editar,
              publicar, reproduzir por meio impresso, digital, redes sociais e
              outros meios de comunicação visual: imagens, conteúdos, enfim,
              toda e qualquer informação do participante relacionada ao prêmio.
            </p>
            <br />
            <p>
              Art. 2° – Os resultados decorrentes da premiação e divulgados pelo
              SP8 PIZZA são inquestionáveis e irrecorríveis.
            </p>
            <br />
            <p>
              Art. 3° – Os vencedores poderão utilizar, para fins de divulgação,
              o prêmio SP8 PIZZA em seu estabelecimento e em todos os seus
              materiais e redes sociais. A logomarca do SP8 PIZZA não poderá, em
              nenhuma circunstância, ter o seu conteúdo, cor ou formato
              alterados. Para a utilização de qualquer outra logomarca, nome ou
              material de propriedade do SP8 PIZZA, será necessária autorização.
            </p>
            <br />
            <p>
              Art. 4° – A participação no SP8 PIZZA implica a aceitação
              irrestrita deste regulamento.
            </p>
            <br />
            <p>
              Art. 5º – Os casos omissos a este regulamento serão resolvidos
              pelos organizadores.
            </p>
          </div>
          <div className="actions">
            <button type="button" onClick={back}>
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Regulamento;
